"use strict";

require("core-js/modules/es6.number.constructor");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = toCurrency;

function toCurrency(stringOrNumber) {
  return stringOrNumber == null || isNaN(Number(stringOrNumber)) ? '0.00' : Number(stringOrNumber).toLocaleString(undefined, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  });
}